import React, { useEffect, useState } from 'react'
import { withRolesAccess } from 'hocs'
import './styles.scss'
import { MultiBrandsAndDelegations, SelectWithLabel, Button } from 'components/Form'
import { lang } from 'utils/helpers'
import Nixi1Spinner from 'components/Nixi1Spinner'
import ConfirmModal from './ConfirmModal'
import MessageModal from './MessageModal'
import { isDisabledButton } from './utils'
import RedirectButton from './RedirectButton'
import CalendarField from 'components/SearchFilters/Filter/CalendarField'
import TimeAndDate from 'utils/TimeAndDate'

const MassiveActionsSelectors = (props) => {
  const {
    actionOptions,
    loadingMassiveAction,
    resetMassiveAction,
    checkResult,
    resultActionOptions,
    onChangeAction,
    isAllSelected,
    onApplyMassAction
  } = props
  const [selectedAction, setSelectedAction] = useState(null)
  const [selectedResultAction, setSelectedResultAction] = useState(null)
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false)
  const [brandsDelegations, setBrandsDelegations] = useState({})
  const [messageAction, setMessageAction] = useState({})
  const [isOpenMessageModal, setIsOpenMessageModal] = useState(false)
  const [historyRange, setHistoryRange] = useState([])

  useEffect(() => {
    if (selectedAction?.withMessage && !isOpenMessageModal) toggleMessageModal()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAction])

  useEffect(() => {
    if (resetMassiveAction) {
      setSelectedAction(null)
      setSelectedResultAction(null)
      setBrandsDelegations({})
      setMessageAction({})
      setHistoryRange([])
    }
  }, [resetMassiveAction])

  const handleOnChangeAction = action => {
    setSelectedAction(action)
    onChangeAction(action?.value || '')

    if (action?.value !== selectedAction?.value) {
      setSelectedResultAction(null)
      setBrandsDelegations({})
      setMessageAction({})
      if (historyRange?.length) setHistoryRange([])
    }
  }
  const toggleConfirmModal = () => setIsOpenConfirmModal(prevState => !prevState)
  const toggleMessageModal = () => setIsOpenMessageModal(prevState => !prevState)

  const handleOnApply = () => {
    const actionData = { action: selectedAction.value }

    const resultAction = Array.isArray(selectedResultAction)
      ? selectedResultAction?.map(it => it.value)
      : selectedResultAction?.value
    if (resultAction) actionData.resultAction = resultAction

    if (selectedAction.value === 'change_centers') {
      const delegations = brandsDelegations.delegations?.map(({ value }) => value)
      if (delegations?.length) actionData.resultAction = delegations
    }

    if (selectedAction.value === 'add_internal_comment') {
      actionData.messageAction = messageAction
    }

    if (selectedAction.value === 'export_csv_with_assigned' && historyRange?.length) {
      const [startAt = '', endAt = ''] = TimeAndDate.betweenEndStartDayUTC(
        historyRange[0],
        historyRange[1]
      )

      actionData.historyRange = {
        isActive: true,
        startAt, endAt
      }
    }

    onApplyMassAction(actionData)
  }

  return (
    <>
      <div className='containerActionsMassive'>
        <SelectWithLabel
          isClearable
          classNameWrapper='select-action-massive'
          label={lang('dashboard_action')}
          placeholder={lang('dashboard_select')}
          options={actionOptions.map(it => ({ ...it, label: lang(it.label), value: it.value }))}
          value={selectedAction}
          onChange={handleOnChangeAction}
          otherProps={{ menuPosition:'fixed' }}
        />
        {!resultActionOptions.loading ? (
            selectedAction?.value === 'change_centers' ? (
              <MultiBrandsAndDelegations
                isClearable
                customClassNameContainer='action-massive-brands-delegations'
                multiple={false}
                label={lang('dashboard_brands-delegations')}
                placeholder={lang('dashboard_select')}
                currentBrands={brandsDelegations.brands || []}
                currentDelegations={brandsDelegations.delegations || []}
                onChange={setBrandsDelegations}
                otherTooltipProps={{ menuPosition:'fixed' }}
              />
            ) : resultActionOptions[selectedAction?.value]?.length ? (
              <SelectWithLabel
                isClearable
                classNameWrapper='select-action-massive'
                label={lang('dashboard_selected-action')}
                placeholder={lang('dashboard_select')}
                options={resultActionOptions[selectedAction.value]}
                value={selectedResultAction}
                onChange={setSelectedResultAction}
                otherProps={{ menuPosition:'fixed' }}
                multi={selectedAction?.multiple}
              />
            ) : (
              <RedirectButton action={selectedAction?.value} />
            )
        ) : (
          <Nixi1Spinner width='20px' height='20px' />
        )}
        {
          selectedAction?.value === 'export_csv_with_assigned'
            ? (
              <div className='container_filter_field field_date'>
                <CalendarField
                  className='select-page-date'
                  imageUrl='icon-calendar.svg'
                  name='historyRange'
                  label={lang('dashboard_select_date_asignation')}
                  subtitle={lang('dashboard_select-date-range')}
                  text={
                    historyRange.length
                      ? historyRange.join(' ~ ')
                      : lang('dashboard_select-date-range')
                  }
                  handleOnChange={(data) => {
                    setHistoryRange(data.filter(e => !!e))
                  }}
                  valueFilters={historyRange}
                  isClear={!!historyRange?.length}
                />
              </div>
            )
            : null
        }
        <Button
          primary
          className='apply-actions-massive-btn'
          disabled={isDisabledButton({
            selectedAction, selectedResultAction, resultActionOptions,
            messageAction, brandsDelegations,
            selectedItems: checkResult || []
          })}
          value={lang('dashboard_apply-changes')}
          onClick={(selectedAction?.withConfirmation || isAllSelected)
            ? toggleConfirmModal
            : handleOnApply
          }
          isSubmitting={loadingMassiveAction}
        />
      </div>

      {isOpenConfirmModal ? (
        <ConfirmModal
          isOpen={isOpenConfirmModal}
          toggle={toggleConfirmModal}
          mainText={!isAllSelected
            ? lang('dashboard_apply-count-conversations', { count: checkResult?.length })
            : lang('dashboard_apply-all-conversations')
          }
          secondaryText={lang('dashboard_sure-apply-changes')}
          alternativeText={lang('dashboard_operation-cannot-undone')}
          onClick={() => {
            handleOnApply()
            toggleConfirmModal()
          }}
        />
      ) : null}

      {isOpenMessageModal ? (
        <MessageModal
          isOpen={isOpenMessageModal}
          toggle={toggleMessageModal}
          value={messageAction.content || messageAction.contentHtml || ''}
          onSave={setMessageAction}
        />
      ) : null}
    </>

  )
}

export default withRolesAccess(MassiveActionsSelectors, 'searchConvMassiveActions')